import { useEffect, useState } from "react";
import config from "../../config";
import { useSelector } from "react-redux";
import QueryString from "query-string";
import { Modal, Spinner } from "react-bootstrap";
import CryptoJS from "crypto-js/aes";
import Utf8 from "crypto-js/enc-utf8";
import { TablePagination } from "@material-ui/core";
import { BsCreditCard } from "react-icons/bs";
import ReactModal from "react-modal";
import { TextField, InputAdornment } from "@material-ui/core";
import { useLocation, useNavigate } from "react-router-dom";
import { Card, Space, Typography, Button, Alert } from "antd";
import Title from "antd/es/typography/Title";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import CustomTable from "../table";
import { useAccess } from "../../provider/AccessProvider";
import { CUSTOMERACCESS } from "../../utils/constant";
import CustomTabs from "../tabs";
const CustomerOutstandings = (props) => {
  const [shopId, setShopId] = useState("");
  const merchantId = useSelector((state) => state.shopDetails.shopId);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [customerPhoneNumber, setCustomerPhoneNumber] = useState("");
  const [bills, setBills] = useState([]);
  const [cal, setCal] = useState();
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [pdf, setPdf] = useState("");
  const [pdfModal, setPdfModal] = useState(false);
  const [billConfirm, setBillConfirm] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [billLoading, setBillLoading] = useState(false);
  const [balanceAmount, setBalanceAmount] = useState(0);
  const [amountReceived, setAmountReceived] = useState("");
  const [pendingAmount, setPendingAmount] = useState(0);
  const [cardType, setCardType] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [billId, setBillId] = useState("");
  const [fullyPaid, setFullyPaid] = useState(false);
  const [billData, setBillData] = useState({});
  const [creditHistoryModal, setCreditHistoryModal] = useState(false);
  const [currentCustomer, setCurrentCustomer] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [amountPaidUsingCard, setAmountPaidUsingCard] = useState("");
  const [amountPaidUsingCash, setAmountPaidUsingCash] = useState("");
  const [amountPaidUsingUpi, setAmountPaidUsingUpi] = useState("");
  const [upiServiceType, setUpiServiceType] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const [result1, setResult1] = useState("0");
  const access = useAccess(CUSTOMERACCESS);
  const [tabKey, setTabKey] = useState("1");
  const [clearedDueBill, setClearedDueBill] = useState([]);
  var recieved = amountReceived;
  //console.log("xx",recieved)
  const [datar, setDatar] = useState("");
  useEffect(() => {
    var rAmount = amountReceived;
    var recieved = amountReceived;
    setCal(recieved);
    if (!rAmount) rAmount = 0;
    var total = (parseFloat(balanceAmount) - parseFloat(rAmount)).toFixed(2);
    console.log("total", total);
    setPendingAmount(total);
  }, [amountReceived]);

  useEffect(() => {
    var paidUsingCash = parseFloat(amountPaidUsingCash)
      ? parseFloat(amountPaidUsingCash)
      : parseFloat(0);
    var paidUsingCard = parseFloat(amountPaidUsingCard)
      ? parseFloat(amountPaidUsingCard)
      : parseFloat(0);
    var paidUsingUpi = parseFloat(amountPaidUsingUpi)
      ? parseFloat(amountPaidUsingUpi)
      : parseFloat(0);
    var totalAmount = paidUsingCash + paidUsingCard + paidUsingUpi;
    tempfunc(totalAmount);
    setAmountReceived(totalAmount);
  }, [amountPaidUsingCard, amountPaidUsingCash, amountPaidUsingUpi]);

  useEffect(() => {
    if (merchantId === "") return;
    let params = QueryString.parse(location.search);
    const bytes = CryptoJS.decrypt(
      params.id
        .replace(/p1L2u3S/g, "+")
        .replace(/s1L2a3S4h/g, "/")
        .replace(/e1Q2u3A4l/g, "="),
      process.env.REACT_APP_CRYPTO_KEY
    );
    const decrypt = bytes.toString(Utf8);
    setCustomerPhoneNumber(decrypt);
    setShopId(merchantId);
  }, [merchantId]);

  useEffect(() => {
    if (shopId) getBillData(shopId);
  }, [shopId]);
  const total_Balance_Amount = (bills) => {
    let result = 0;
    bills.forEach((i) => {
      if (i.billCancelled) {
        result += 0;
      } else {
        result +=
          (parseFloat(i.balanceAmount) || 0) > 0
            ? parseFloat(i.balanceAmount) || 0
            : 0;
      }
    });
    return result;
  };
  useEffect(() => {
    if (bills.length > 0) {
      getInvoiceDetails();
      const totalBalanceAmount = total_Balance_Amount(bills);
      //alert(totalBalanceAmount);
      setResult1(totalBalanceAmount);
    }
  }, [bills]);

  const getBillData = async () => {
    setIsLoading(true);
    try {
      var res = await fetch(
        `${config.newApiGateway}/customer/getCustomerBillDetails`,
        {
          method: "POST",
          body: JSON.stringify({
            phoneNumber: customerPhoneNumber,
            shopId: shopId,
          }),
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
        }
      );
      res = await res.json();
      if (res.code === "ERROR") return alert(res.message);
      else {
        if (res !== undefined) {
          if (res.limitExceeds && res.status) {
            try {
              var s3Bills = await fetch(res.data);
              s3Bills = await s3Bills.json();
              const filteredBillData = s3Bills.filter((i) => {
                return i.type === "bill";
              });
              setBills(filteredBillData);
              setIsLoading(false);
              return;
            } catch (err) {
              alert("Failed to fetch Customer bills.");
              setIsLoading(false);
              return;
            }
          }
          const filteredBillData = res.data.filter((i) => {
            return i.type === "bill";
          });
          setBills(filteredBillData);
          setIsLoading(false);
        }
      }
    } catch (err) {
      console.log("Err", err);
    }
  };

  const getInvoiceDetails = () => {
    let refactoredData = bills.map((data) => {
      setDatar(data);
      return {
        billId: data.billId,
        billingDate: data.billingDate,
        invoiceNumber: data.invoicePrefix
          ? data.invoicePrefix + data.invoiceNumber.toString()
          : data.invoiceNumber.toString(),
        customerName: data.customerName,
        customerPhoneNumber: data.customerPhoneNumber,
        amountPaid: data.amountPaid,
        balanceAmount:
          data.billCancelled === true
            ? 0
            : parseFloat(data.balanceAmount ? data.balanceAmount : 0.0).toFixed(
                2
              ),
        isCreditClearBill: data.creditHistory?.some(
          (i) => i.balanceAmount === 0
        ),
        creditHistory: data.creditHistory ? data.creditHistory : [],
      };
    });

    const filteredData = refactoredData
      .filter((data) => parseFloat(data.balanceAmount) > 0)
      .sort((a, b) => {
        if (new Date(a.billingDate) < new Date(b.billingDate)) return 1;
        if (new Date(a.billingDate) > new Date(b.billingDate)) return -1;
        if (new Date(a.billingDate) === new Date(b.billingDate)) {
          if (a.invoiceNumber < b.invoiceNumber) return 1;
          if (a.invoiceNumber > b.invoiceNumber) return -1;
          return 0;
        }
      });
    const clearedBill = refactoredData.filter((i) => {
      return parseFloat(i.balanceAmount) === 0 && i.isCreditClearBill;
    });

    setClearedDueBill(clearedBill);
    setCurrentCustomer(bills[0]);
    setInvoiceDetails(filteredData);
  };
  const tempfunc = (totalAmount) => {
    let amountpay = totalAmount;
    let temporary = invoiceDetails.map((data) => {
      let balancetopay = parseFloat(data.balanceAmount);
      if (amountpay > 0) {
        if (amountpay > balancetopay) {
          amountpay = amountpay - balancetopay;
          balancetopay = 0;
          //amountpay=amountpay1;

          return {
            ...data,
            isChecked: true,
          };
        } else if (amountpay <= balancetopay) {
          balancetopay = balancetopay - amountpay;
          amountpay = 0;

          return {
            ...data,
            isChecked: true,
          };
        }
      } else {
        return {
          ...data,
          isChecked: false,
        };
      }
    });
    setInvoiceDetails(temporary);
  };

  useEffect(() => {
    if (fullyPaid) setAmountReceived(balanceAmount);
  }, [fullyPaid]);

  const payBalanceHandler = (data) => {
    setBalanceAmount(data.balanceAmount);
    setPendingAmount(data.balanceAmount);
    setBillConfirm(true);
    setBillId(data.billId);
  };
  const payBalanceHandler1 = (datar) => {
    setBalanceAmount(datar.balanceAmount);
    setPendingAmount(datar.balanceAmount);
    setBillConfirm(true);
    setBillId(datar.billId);
  };
  const updateBillBalance = async () => {
    if (!amountReceived) return alert("Please enter amount received.");
    if (!amountPaidUsingCash && !amountPaidUsingCard && !amountPaidUsingUpi) {
      return alert("Please enter amount received");
    }
    if (parseFloat(amountReceived) <= 0)
      return alert("Amount received should be greater than zero.");
    if (amountPaidUsingCash) {
      var obj = {
        method: "cash",
        amountPaid: amountPaidUsingCash,
      };
      paymentMethod.push(obj);
    }
    if (amountPaidUsingCard) {
      // if (cardType) {
      //   if (!cardNumber) {
      //     setPaymentMethod([]);
      //     return alert("Please enter last four digits of card number");
      //   }
      // } else {
      //   setPaymentMethod([]);
      //   return alert("select card type");
      // }
      var obj = {
        method: "card",
        amountPaid: amountPaidUsingCard,
        cardType: cardType,
        cardNumber: cardNumber,
      };
      paymentMethod.push(obj);
    }
    if (amountPaidUsingUpi) {
      // if (!upiServiceType) {
      //   setPaymentMethod([]);
      //   return alert("Select upi service");
      // }
      var obj = {
        method: "upi",
        amountPaid: amountPaidUsingUpi,
        upiService: upiServiceType,
      };
      paymentMethod.push(obj);
    }
    setBillLoading(true);
    try {
      var res = await fetch(`${config.newApiGateway}/tools/clearCredits`, {
        method: "POST",
        body: JSON.stringify({
          amount: amountReceived,
          paymentMethod: [
            {
              method: "Not Returned",
            },
          ],
          amountPaidUsingCash: amountPaidUsingCash,
          amountPaidUsingUpi: amountPaidUsingUpi,
          amountPaidUsingCard: amountPaidUsingCard,
          paymentMethod: paymentMethod,
          cardNumber: cardNumber,
          cardType: cardType,
          billdetails: invoiceDetails,
          // billId: billId,
          // balanceAmount: balanceAmount,
          // amountPaid: amountReceived,
          // paymentMethod: paymentMethod,
          // cardNumber: cardNumber,
          // cardType: cardType,
          // updatedDate: new Date().toISOString().substring(0, 10),
          updatedTime: new Date().toLocaleString("en-IN", {
            hour12: true,
            hour: "2-digit",
            minute: "2-digit",
          }),
          updatedBy: shopDetails.phoneNumber,
          updatedByName: shopDetails.empId
            ? shopDetails.employeeName
            : "Shop Owner",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      res = await res.json();
      if (res[0].code === "ERROR") {
        console.log("Res", res);
        setBillLoading(false);
        return alert(res[0].message);
      }
      if (res[0]?.code === "SUCCESS") {
        resetToDefault();
        getBillData(shopId);
        resetToDefault();
      }
    } catch (err) {
      console.log("Err", err);
      setBillLoading(false);
      alert("Error while update balance. Please try again.");
    }
  };
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "700px",
    },
  };

  const viewCreditHistory = (data) => {
    setBillData(data);
    setCreditHistoryModal(true);
  };

  const resetToDefault = () => {
    setBillConfirm(false);
    setBillLoading(false);
    setBalanceAmount(0);
    setAmountReceived("");
    setAmountPaidUsingCard("");
    setAmountPaidUsingCash("");
    setAmountPaidUsingUpi("");
    setPendingAmount(0);
    setPaymentMethod([]);
    setCardNumber("");
    setCardType("");
    setBillId("");
  };

  const exportHead = ["Date", "Invoice Number", "Bill Amount", "Outstanding"];
  const exportValue = [
    "billingDate",
    "invoiceNumber",
    "amountPaid",
    "balanceAmount",
  ];

  const tableColumns = [
    {
      title: "Date",
      dataIndex: "billingDate",
      //defaultSort: "desc",
      headerStyle: {
        zIndex: "0",
      },
    },
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      //defaultSort: "desc",
      headerStyle: {
        zIndex: "0",
      },
    },
    {
      title: `Bill Amount(${country.CurrencySymbol})`,
      headerStyle: {
        zIndex: "0",
      },
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.amountPaid)}</div>;
      },
    },
    {
      title: `Outstanding(${country.CurrencySymbol})`,
      headerStyle: {
        zIndex: "0",
      },
      render: (rowData) => {
        return (
          <>
            <div>{currencyFormatter(rowData.balanceAmount)}</div>
          </>
        );
      },
    },
    {
      title: "Actions",
      headerStyle: {
        zIndex: "0",
      },
      render: (data) => {
        return (
          <Button
            type="link"
            onClick={() => {
              viewCreditHistory(data);
            }}
          >
            History
          </Button>
        );
      },
    },
  ];

  if (!access.outstanding(false)) {
    <Alert
      style={{
        padding: "20px",
        textAlign: "center",
      }}
      message="You don't have access, Please contact your administrator to request the appropriate access."
      type="error"
    />;
  }

  const tabs = [
    {
      key: "1",
      label: "Outstanding",
    },
    {
      key: "2",
      label: "Cleared Due",
    },
  ];

  const clearedTableColumns = [
    {
      title: "Date",
      dataIndex: "billingDate",
      //defaultSort: "desc",
      headerStyle: {
        zIndex: "0",
      },
    },
    {
      title: "Invoice Number",
      dataIndex: "invoiceNumber",
      //defaultSort: "desc",
      headerStyle: {
        zIndex: "0",
      },
    },
    {
      title: `Bill Amount(${country.CurrencySymbol})`,
      headerStyle: {
        zIndex: "0",
      },
      render: (rowData) => {
        return <div>{currencyFormatter(rowData.amountPaid)}</div>;
      },
    },
    {
      title: `Cleared Due(${country.CurrencySymbol})`,
      headerStyle: {
        zIndex: "0",
      },
      render: (rowData) => {
        const amount = rowData.creditHistory?.reduce(
          (acc, curr) => acc + curr.amountPaid,
          0
        );
        return <div>{currencyFormatter(amount)}</div>;
      },
    },
    {
      title: "Actions",
      headerStyle: {
        zIndex: "0",
      },
      render: (data) => {
        return (
          <Button
            type="link"
            onClick={() => {
              viewCreditHistory(data);
            }}
          >
            History
          </Button>
        );
      },
    },
  ];

  return (
    <div>
      <Card
        bodyStyle={{
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
        style={{
          marginBottom: 20,
        }}
      >
        <Space direction="vertical">
          <Title
            style={{
              margin: 0,
            }}
            level={5}
          >
            Name:{" "}
            <Typography.Text type="secondary">
              {currentCustomer.customerName ? currentCustomer.customerName : ""}
            </Typography.Text>
          </Title>
          <Title
            style={{
              margin: 0,
            }}
            level={5}
          >
            Mobile Number:{" "}
            <Typography.Text type="secondary">
              {currentCustomer.customerPhoneNumber
                ? currentCustomer.customerPhoneNumber
                : ""}
            </Typography.Text>
          </Title>
          <Title
            style={{
              margin: 0,
            }}
            level={5}
          >
            Balance Outstanding:
            <Typography.Text type="secondary">
              {" "}
              {currencyFormatter(parseFloat(result1))}
            </Typography.Text>
          </Title>
        </Space>
        {Boolean(result1) && (
          <Button
            type="primary"
            style={{
              marginLeft: "auto",
            }}
            onClick={() => {
              const isAccess = access.outstanding();
              if (!isAccess) {
                return;
              }
              payBalanceHandler1(datar);
            }}
          >
            Clear credits
          </Button>
        )}
      </Card>
      <CustomTabs
        activeKey={tabKey}
        items={tabs}
        style={{
          marginBottom: "20px",
        }}
        onTabChange={(v) => setTabKey(v)}
      />
      {tabKey === "1" && (
        <CustomTable
          columns={tableColumns}
          title={"Outstanding"}
          data={invoiceDetails}
          loading={isLoading}
          excelExport={true}
          exportHead={exportHead}
          exportValue={exportValue}
        />
      )}

      {tabKey === "2" && (
        <CustomTable
          columns={clearedTableColumns}
          title={"Cleared Due"}
          data={clearedDueBill}
          loading={isLoading}
        />
      )}

      <div>
        {/* <div>
          <h5>
            Name:{" "}
            {currentCustomer !== undefined ? currentCustomer.customerName : ""}
          </h5>
          <h6>
            Mobile Number:{" "}
            {currentCustomer !== undefined
              ? currentCustomer.customerPhoneNumber
              : 0}
          </h6>
          <h6>
            Balance Outstanding:{"  "}
            {parseFloat(result1).toFixed(2)}
          </h6>
          {Boolean(result1) && (
            <div>
              <Button
                style={{ position: "absolute", right: "30px", top: "130px" }}
                onClick={() => {
                  payBalanceHandler1(datar);
                }}
              >
                Clear credits
              </Button>
            </div>
          )}
        </div> */}
        {/* <div className="cm-table">
          <MaterialTable
            data={invoiceDetails}
            columns={[
              {
                title: "Check Box",
                field: "isChecked",
                headerStyle: {
                  zIndex: "0",
                },
                render: (rowdata) => (
                  <input type="checkbox" disabled checked={rowdata.isChecked} />
                ),
              },
              {
                title: "Date",
                field: "billingDate",
                //defaultSort: "desc",
                headerStyle: {
                  zIndex: "0",
                },
              },
              {
                title: "Invoice Number",
                field: "invoiceNumber",
                //defaultSort: "desc",
                headerStyle: {
                  zIndex: "0",
                },
              },
              {
                title: "Bill Amount(${country.CurrencySymbol})",
                field: "amountPaid",
                headerStyle: {
                  zIndex: "0",
                },
                render: (rowData) => {
                  return <div>{currencyFormatter(rowData.amountPaid)}</div>;
                },
              },
              {
                title: "Outstanding(${country.CurrencySymbol})",
                field: "balanceAmount",
                headerStyle: {
                  zIndex: "0",
                },
                render: (rowData) => {
                  return (
                    <>
                      <div>{currencyFormatter(rowData.balanceAmount)}</div>
                    </>
                  );
                },
              },
              {
                title: "Actions",
                headerStyle: {
                  zIndex: "0",
                },
                //   render: (data) => {
                //     return (
                //       <>
                //         {parseInt(data.balanceAmount) > 0 && (
                //           <Button
                //             onClick={() => {
                //               payBalanceHandler(data);
                //             }}
                //           >
                //             Clear credits
                //           </Button>
                //         )}{" "}
                //       </>
                //     );
                //   },
                // },
                // {
                render: (data) => {
                  return (
                    <Button
                      onClick={() => {
                        viewCreditHistory(data);
                      }}
                    >
                      History
                    </Button>
                  );
                },
              },
            ]}
            title="Outstandings"
            icons={tableIcons}
            isLoading={isLoading}
            options={{
              pageSize: 10,
              emptyRowsWhenPaging: true,
              pageSizeOptions: [10, 20, 50, 100, 500],
            }}
            components={{
              Pagination: PatchedPagination,
            }}
            // });
          />
        </div> */}
      </div>

      <Modal
        dialogClassName="custom-pdf-modal"
        show={pdfModal}
        onHide={() => {
          setPdfModal(false);
        }}
      >
        <Modal.Body>
          <div style={{ height: "200px !important" }}>
            <embed
              src={pdf}
              style={{ height: "580px", width: "500px" }}
              type="application/pdf"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              setPdfModal(false);
            }}
            ghost
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <ReactModal isOpen={billConfirm} style={customStyles}>
        <div>
          <div
            className="clearCreditsClosure"
            onClick={() => setBillConfirm(false)}
          >
            x
          </div>
          <div className="clearCreditMain">
            <div className="balanceAmountContainer">
              <div className="creditbalanceamount">
                <div>
                  {result1 >= 0 ? (
                    <>Balance Amount</>
                  ) : result1 < 0 ? (
                    <>Remaining Amount</>
                  ) : (
                    <></>
                  )}
                </div>
                <div style={{ color: "#208441", fontWeight: "600" }}>
                  {result1 > 0 ? (
                    <>{currencyFormatter(result1)}</>
                  ) : result1 <= 0 ? (
                    <>{currencyFormatter(result1)}</>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
            <div className="payCreditAmountContainer">
              <div>Amount Received</div>
              <div className="clearcredittextfields">
                <div className="cashSection">
                  <TextField
                    id="cashAmount"
                    size="small"
                    label="cash"
                    variant="outlined"
                    style={{ width: "280px" }}
                    value={amountPaidUsingCash}
                    onChange={(e) => setAmountPaidUsingCash(e.target.value)}
                    placeholder="Cash Amount Paid"
                    inputProps={{
                      maxLength: 8,
                      pattern: "/[A-Za-z]{3}/",
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {country.CurrencySymbol}
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>

                {/* <hr style={{ fontSize: "1px" }}></hr>
                <div className="upiSection">
                  <TextField
                    id="upiAmount"
                    size="small"
                    label="Upi"
                    variant="outlined"
                    value={amountPaidUsingUpi}
                    style={{ width: "280px" }}
                    onChange={(e) => setAmountPaidUsingUpi(e.target.value)}
                    placeholder="Upi Amount Paid"
                    inputProps={{
                      maxLength: 8,
                      pattern: "/[A-Za-z]{3}/",
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">UPI</InputAdornment>
                      ),
                    }}
                  />
                </div> */}
                <div className="upiSection">
                  <TextField
                    id="upiAmount"
                    size="small"
                    label="Upi"
                    variant="outlined"
                    value={amountPaidUsingUpi}
                    style={{ width: "280px" }}
                    onChange={(e) => setAmountPaidUsingUpi(e.target.value)}
                    placeholder="Upi Amount Paid"
                    inputProps={{
                      maxLength: 8,
                      pattern: "/[A-Za-z]{3}/",
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">UPI</InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="cardSection">
                  <TextField
                    id="cardAmount"
                    size="small"
                    label="card"
                    variant="outlined"
                    style={{ width: "280px" }}
                    value={amountPaidUsingCard}
                    onChange={(e) => setAmountPaidUsingCard(e.target.value)}
                    placeholder="Card Amount Paid"
                    inputProps={{
                      maxLength: 8,
                      pattern: "/[A-Za-z]{3}/",
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <BsCreditCard />
                        </InputAdornment>
                      ),
                    }}
                  />

                  <div className="chooseCardTypeSection">
                    <div>
                      <select
                        value={cardType}
                        className="selectOfChooseCardType"
                        style={{ width: "130px" }}
                        onChange={(e) => setCardType(e.target.value)}
                      >
                        <option value="" disabled>
                          card type
                        </option>
                        <option value="visa">Visa</option>
                        <option value="masterCard">Master Card</option>
                        <option value="rupay">Rupay</option>
                      </select>
                    </div>
                    <div>
                      <input
                        style={{ width: "130px" }}
                        type="number"
                        className="inputOfChooseCardType"
                        value={cardNumber}
                        onChange={(e) => setCardNumber(e.target.value)}
                        placeholder="Enter last 4 digit"
                        maxLength={4}
                      />
                    </div>
                  </div>
                </div>
                {/* <hr style={{ fontSize: "1px" }}></hr> */}
              </div>

              <div>
                {!billLoading ? (
                  <div style={{ textAlign: "center" }}>
                    {/* <button
                    disabled={billLoading}
                    onClick={() => resetToDefault()}
                  >
                    Cancel
                  </button> */}
                    <button
                      className="confirmBillNew"
                      disabled={billLoading}
                      onClick={() => updateBillBalance()}
                    >
                      Confirm
                    </button>
                  </div>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      margin: "20px 0px 20px 0px",
                    }}
                  >
                    <Spinner animation="border" variant="secondary" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
      <Modal centered show={creditHistoryModal}>
        <Modal.Header>
          <Title
            style={{
              marginBottom: 0,
            }}
            level={4}
          >
            Outstanding history
          </Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {Object.keys(billData).length > 0 && (
              <div>
                {billData.creditHistory.length > 0 ? (
                  <>
                    {billData.creditHistory.map((data) => {
                      // console.log("DATA LOADED", data);
                      var paidUsing = "";
                      if (Array.isArray(data.paymentMethod)) {
                        var response = data.paymentMethod.map((val) => {
                          return `${val.method} ( ${currencyFormatter(
                            val.amountPaid
                          )})`;
                        });

                        paidUsing = response.toString();

                        // console.log("Paid Using when array", paidUsing);
                      } else {
                        paidUsing = data.paymentMethod;
                        // console.log("Paid Using when string", paidUsing);
                      }
                      return (
                        <>
                          {paidUsing ? (
                            <p>
                              Cleared outstanding of {country.CurrencySymbol}
                              {data.amountPaid} on {data.updatedDate}{" "}
                              {data.updatedTime} via {paidUsing} by{" "}
                              {data.updatedBy} (
                              {data.updatedBy === shopDetails.phoneNumber
                                ? "You"
                                : data.updatedByName}
                              ). Pending Amount:{country.CurrencySymbol}
                              {data.balanceAmount}
                            </p>
                          ) : (
                            <p>
                              Cleared outstanding of {country.CurrencySymbol}
                              {data.amountPaid} on {data.updatedDate}{" "}
                              {data.updatedTime},Nothing is cleared from this
                              bill.
                            </p>
                          )}
                          <hr />
                        </>
                      );
                    })}
                  </>
                ) : (
                  <>No history found!...</>
                )}
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            type="primary"
            onClick={() => {
              setCreditHistoryModal(false);
              setBillData({});
            }}
            ghost
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default CustomerOutstandings;
